import { MemoizedSelector, createFeatureSelector } from '@ngrx/store';
import { PRICE_FILE_FEATURE, PriceFileState, StateWithPriceFile } from '../price-file-state';

export const getPriceFileState: MemoizedSelector<StateWithPriceFile, PriceFileState> =
  createFeatureSelector<PriceFileState>(PRICE_FILE_FEATURE);
